<template>
  <div id="game" class="game">
      <h2 class="game-title"><span>GAMES</span></h2>
      <!-- <div class="short-line center-block"></div> -->
      <SLine c="white"></SLine>
      <div class=" games">
        <div class="game-item">
          <img src="../assets/dig.png">
          <p class="game-item-title"><a target="blank" href="https://play.google.com/store/apps/details?id=com.joyepic.survivor">Last Survivors - Adventure</a></p>
          <p>Casual and relaxing, enjoyable and fatigue-free. Open chests to get equipment!
Choose from over 100 different equipments to boost your power and defeat the zombies.</p>
        </div>
        <!-- <div class="game-item">
          <img src="../assets/kos.png">
          <p class="game-item-title">Lucky Bull</p>
          <p><span>A lucky bull is carefree grazing</span></p>
        </div> -->
      </div>
  </div>
</template>

<script>
import SLine from './Item_center_line'
export default {
  components:{
    SLine,
  }
}
</script>
<style>
  .game-item-title{
    font-size: 20px;
  }
  .game-item p{
    margin:20px;
    line-height:1.5em;
  }
  .game-item{
    width: 300px;
    margin: 30px auto;
  }
  .games{
    margin-top: 70px;
    display: flex;
  }
  .short-line{
    margin-top: 25px;
    width: 40px;
    height: 2px;
    background: white;
  }
  .game-title{
    padding-top: 100px;
  }
  .game{
    height: 800px;
    background: black;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Game.vue